// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1AQ5A","noInteraction":"EventWrapper_noInteraction__BNsXN"};